import { z } from "zod";
import { normalizeOrdinaryTimeOnly } from "@membentry/shared-types";
export const supportedClubCurrencies = [
    "BAM",
    "EUR",
    "USD",
    "RSD",
    "MKD",
    "ALL",
];
const defaultValidationTranslate = (key, params) => {
    const fallbackMessages = {
        required: "This field is required",
        invalidEmail: "Invalid email address",
        invalidUrl: "Must be a valid URL",
        maxLength: "Maximum length is {{max}} characters",
    };
    const message = fallbackMessages[key] ?? key;
    return Object.entries(params ?? {}).reduce((current, [paramKey, value]) => current.split(`{{${paramKey}}}`).join(String(value)), message);
};
export const clubAddressSchema = z
    .union([
    z
        .object({
        street: z.string().trim().max(0),
        city: z.string().trim().max(0),
        state: z.string().trim().max(0),
        postalCode: z.string().trim().max(0),
        country: z.string().trim().max(0),
    })
        .transform(() => null),
    z.object({
        street: z.string().trim().min(1).max(100),
        city: z.string().trim().min(1).max(50),
        state: z.string().trim().min(1).max(50),
        postalCode: z.string().trim().min(1).max(20),
        country: z.string().trim().min(1).max(50),
    }),
])
    .optional()
    .nullable();
export const clubTimeOnlySchema = z
    .string()
    .refine((value) => normalizeOrdinaryTimeOnly(value) === value, {
    message: "Time must use HH:mm",
});
export function createLocalizedClubSchema(t = defaultValidationTranslate) {
    return z.object({
        name: z.string().min(1, t("required")),
        location: z.string().min(1, t("required")),
        ownerId: z.string().optional().nullable(),
        address: clubAddressSchema,
        coverImageUrl: z.url(t("invalidUrl")).optional().nullable(),
        logoImageUrl: z
            .url(t("invalidUrl"))
            .max(500, t("maxLength", { max: 500 }))
            .optional()
            .nullable(),
        phoneNumber: z.string().optional().nullable(),
        email: z.email(t("invalidEmail")).optional().nullable(),
        description: z
            .string()
            .max(500, t("maxLength", { max: 500 }))
            .optional()
            .nullable(),
        facilities: z.string().optional().nullable(),
        openingTime: clubTimeOnlySchema.optional().nullable(),
        closingTime: clubTimeOnlySchema.optional().nullable(),
        facebookUrl: z.url(t("invalidUrl")).optional().nullable(),
        instagramUrl: z.url(t("invalidUrl")).optional().nullable(),
        currency: z.enum(supportedClubCurrencies).default("BAM"),
    });
}
export const createClubSchema = createLocalizedClubSchema();
export const updateClubSchema = createClubSchema.partial();
